import axios from "axios";
import { push } from "connected-react-router";
import store from "../redux/store";
import { setToken } from "../redux/auth";
import { setErrorMessage } from "../redux/errors";
import { apiKey } from "../config/api";
import { encodeStr, mapErrorMessage } from "../utils";

const env = process.env.REACT_APP_ENV;
let baseURL = "https://no-prod-api.bancopatagonia.com.ar/qa/personas";

if (env && env === "testing") {
  baseURL = "https://no-prod-api.bancopatagonia.com.ar/qa/personas";
} else if (env === "prod") {
  baseURL = "https://api.bancopatagonia.com.ar/pro/personas";
}

const axiosClient = axios.create({ baseURL });

axiosClient.defaults.headers.common["Content-Type"] =
  "application/x-www-form-urlencoded";
axiosClient.defaults.headers.common["Accept"] = "application/json";

// Add request interceptors
axiosClient.interceptors.request.use(
  (config) => {
    config.params = { ...config.params, "gw-app-key": apiKey(env) };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Add response interceptors
axiosClient.interceptors.response.use(
  (response) => {
    const { "x-access-token": accessToken, "x-uid": uid } = response.headers;
    const newToken = encodeStr(`${uid}:${accessToken}`);
    store.dispatch(setToken(newToken));
    localStorage.setItem('token', newToken)
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(setErrorMessage(mapErrorMessage("invalidToken")));
      store.dispatch(push("/error"));
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
